import { equals, uniq, pipe, flatten, includes } from 'ramda';
import ColumnName from '@/util/ColumnName';
import { NO_CONFIGURATION } from './constants';
import { TConfigurationRule } from './types';

export const isNotConfigurable = equals<TConfigurationRule>(NO_CONFIGURATION);

const flattenUnique = pipe(flatten, uniq);

export const groupMetricsByRule = <T>(
  rule: TConfigurationRule,
  options: T[],
  size: number,
): T[][] => {
  return new Array(size).fill(options);
};

export function getAvailableDimensions(
  combinations: Maybe<ColumnName[][]>,
  dependant: Maybe<ColumnName[]>,
) {
  if (!combinations || combinations.length === 0) {
    return [];
  }

  if (!dependant || dependant.length === 0) {
    return flattenUnique(combinations);
  }

  const foundCombinations = combinations.filter((combination) =>
    dependant.every((d) => includes(d, combination)),
  );

  return flattenUnique(foundCombinations).filter(
    (c) => !includes(c, dependant),
  );
}
